import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import { Container, Row, Col, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { setRemovedSurfSocResult } from '../../cellcomAbroadBlockSlice'
import images from '../images/images'
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import './SuccessfulPackageInstall.scss';
import Lottie from 'react-lottie';
import PisaTower from '../../../../../animations/fallingTower.json';
import {isMobileOnly} from 'react-device-detect';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';


function SuccessfulSurfBlockRemoved({ onClose, setRemovedSurfSocResult, removedSurfSocResult }) {

    const btnTxt = `חזור לחו"ל שלי`;
    const regTxt = `עכשיו ניתן לגלוש בראש שקט בחו"ל`;
    const header =`חסימת הגלישה הוסרה`
    const failedHeader = `אוי לא, משהוא השתבש`
    const failedBtnTxt = `סיום`;
    const failedRegTxt = `לצערנו לא הצלחנו לבטל את חסימה הגלישה במנוי שלך`
    const boldTxt = `מוקד ${window.Config.brand_Name_HE} חו\"ל זמין 24\\7 <br /> בשיחת חינם גם מחו\"ל <br /> ${window.Config.numberCallCenterAbroad}`;

    function goBack() {
        setRemovedSurfSocResult(null);
        onClose();
    }

    function renderRemovedOrFailed() {
        if(removedSurfSocResult == true) {
            return (
                <div className="SuccessfulPackageInstall-container">
                    <div className="SuccessfulPackageInstall-header" dangerouslySetInnerHTML={{__html: header}}></div>
                    <Image src={images.okDone} alt="ok" className="ok-img" />
                    <div className="SuccessfulPackageInstall-data-box">
                    <div className="data-box-reg">{regTxt}</div>
                        {/* <div className="data-box-strong" dangerouslySetInnerHTML={{__html: boldTxt}}></div> */}
                    </div>
                    <BtnSubmit text={btnTxt} onclick={() => goBack()}/>
                </div>
            )
        } else {
            return (
                <div className="SuccessfulPackageInstall-container">
                    <div className="SuccessfulPackageInstall-header" dangerouslySetInnerHTML={{__html: failedHeader}}></div>
                    {/* <Lottie  options={{animationData: PisaTower, loop: false}} width={isMobileOnly ? 80 : 125} /> */}
                    <ThemedLottie animationData={PisaTower} color={ThemeColorEnum.PRIMARY} width={isMobileOnly ? 80 : 125} loop={false} />
                    <div className="SuccessfulPackageInstall-data-box">
                    <div className="data-box-reg">{failedRegTxt}</div>
                        <div className="data-box-strong" dangerouslySetInnerHTML={{__html: boldTxt}}></div>
                    </div>
                    <BtnSubmit text={failedBtnTxt} onclick={() => goBack()}/>
                </div>
            )
        }
    }

    return (
        renderRemovedOrFailed()
    )
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
    setRemovedSurfSocResult
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessfulSurfBlockRemoved);
